module.exports = __webpack_public_path__ + "img/frameBackgroundImg.f6187804.png";